/* eslint-disable react/no-array-index-key */
// eslint-disable-next-line import/no-extraneous-dependencies
import { Box } from '@mui/material';
import Typography from '@digital-hig/typography';
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const UnorderedList = ({
  data = [],
  title,
}) => {
  const { t } = useTranslation('');
  return (
    <Box component="ul">
      <Typography variant="headline-medium" mb={4}>
        {t(title)}
      </Typography>
      {(!!data.length) && data.map((element, index) => <Typography key={`li-${index}-${element}`} component="li">{t(element)}</Typography>) }
    </Box>
  );
};
UnorderedList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string,
};
UnorderedList.defaultProps = {
  data: [],
  title: '',
};
export default UnorderedList;
